import { type ReactNode, useState } from "react";
import { ConfigProvider, Flex } from "antd";

import { SecurityGroupDetail } from "./SecurityGroupDetail";
import { SecurityGroupSummaryList } from "./SecurityGroupSummaryList";
import { useFetchSecurityGroupUsers } from "../../../../../services/admin-settings/security-groups";

import type { SecurityGroupSummary } from "../../../../../services/admin-settings/type";

type SecurityGroupsViewProps = {
  rolesAndPermissionsContent?: (group: SecurityGroupSummary) => ReactNode;
};

export function SecurityGroupsView({ rolesAndPermissionsContent }: SecurityGroupsViewProps) {
  const [selectedGroup, setSelectedGroup] = useState<SecurityGroupSummary>();
  const { data: users, isLoading, isFetching } = useFetchSecurityGroupUsers(selectedGroup?.id);
  // Cached members can lag a refreshed summary, so only a settled fetch overrides the summary count.
  const selectedUserCount = isFetching ? undefined : users?.length;

  return (
    // Figma's opaque neutral fill is local; colorFillAlter would blend with the shared gray drawer.
    <Flex style={{ backgroundColor: "#fafafa" }}>
      <ConfigProvider
        theme={{
          // These Figma values belong to this sidebar, not the shared application palette.
          token: { colorInfoBg: "#e3eafb", colorPrimaryTextHover: "#5582ec" },
        }}
      >
        <SecurityGroupSummaryList
          selectedGroupId={selectedGroup?.id}
          selectedUserCount={selectedUserCount}
          onSelectGroup={setSelectedGroup}
        />
      </ConfigProvider>
      {selectedGroup && (
        <SecurityGroupDetail
          key={selectedGroup.id}
          group={selectedGroup}
          users={users}
          isLoading={isLoading}
          rolesAndPermissionsContent={rolesAndPermissionsContent?.(selectedGroup)}
        />
      )}
    </Flex>
  );
}
